var utils = require('../../utils')
import AppHeader from '../AppHeader'
import ShiftImportDialog from '../ShiftImportDialog'
import $ from 'jquery'
global.jQuery = $;
window.jQuery = $;

export default {
  name: 'shift-create',
  created () {
    // 店舗名取得
    this.getMyShopDetail()
    this.getShop()
    // 初期シフトデータ取得
    this.search(true)
    this.checkedData = []
    // ブラウザの判定
    var userAgent = window.navigator.userAgent.toLowerCase()
    if(userAgent.indexOf('chrome') != -1 && userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1) {
      this.msChromeFlag = true
    }
  },
  mounted () {
    window.addEventListener('keyup', this.judgeKeyCode, false)
    this.$nextTick(() => {
      window.addEventListener('scroll', this.fixedTableHead, false)
    })
  },
  updated () {
    if (this.searchCallbackFlag) {
      this.setCheckboxDisabledFlag === false && this.setCheckboxDisabled()
      let shift = document.getElementById('is-scroll-body')
      let shiftDate = document.getElementById('is-scroll-date')
      shift.addEventListener('scroll', function () {
        shiftDate.scrollLeft = shift.scrollLeft
      })
      shiftDate.addEventListener('scroll', function () {
        shift.scrollLeft = shiftDate.scrollLeft
      })
    }
    if (this.modalFlag && this.modalData['shift']) {
      // v-modelを使用すると入力の際に全再描画され遅いので、v-modelは使用しない
      $('#modal_comment').val(this.modalData['shift']['comment'])
      $('#modal_time_from_hh').val(this.modalData['shift']['time_from_hh'])
      $('#modal_time_from_mm').val(this.modalData['shift']['time_from_mm'])
      $('#modal_time_to_hh').val(this.modalData['shift']['time_to_hh'])
      $('#modal_time_to_mm').val(this.modalData['shift']['time_to_mm'])
      $('#modal_break_time').val(this.modalData['shift']['break_time'])
    }
    if (this.modalFlag && this.modalData['shiftClass']) {
      this.controlModalInputDisabled(this.modalData['shiftClass']['class_name'])
    }
  },
  beforeRouteLeave (to, from, next) {
    window.removeEventListener('keyup', this.judgeKeyCode, false)
    window.removeEventListener('scroll', this.fixedTableHead, false)
    next()
  },
  data () {
    return {
      msChromeFlag: false,
      modalFlag: false,
      changeAllModalFlag: false,
      changeAllModalData: {
        key: null,
        shift: null
      },
      changeAllModalSelectBoxFlag: false,
      modalSelectBoxFlag: false,
      modalData: {
        key: null,
        index: null,
        shift_date: null,
        shift: null,
        shiftClass: null
      },
      classData: {
        view_name: null,
        select_name: null,
        class_name: null,
        time_from_hh: null,
        time_from_mm: null,
        time_to_hh: null,
        time_to_mm: null,
        break_time: null,
        is_default: null
      },
      searchCallbackFlag: false,
      shopName: null,
      selectYear: this.getSelectedYear(),
      selectMonth: this.getSelectedMonth(),
      selectUserTypes: {},
      selectUserType: [],
      workUserTypeShifts: {},
      shiftShopConfigurations: null,
      editShifts: null,
      isDisableSaveButton: true,
      isDisableCurrentMonth: false,
      isNeedSaveFlag: false,
      checkedData: [],
      setCheckboxDisabledFlag: false,
      searchShop: '',
      // Excel 取込ダイアログ（F-SFT-02）
      importDialogFlag: false
    }
  },
  computed: {
    shift_dates () {
      return this.$store.getters.shift_dates
    },
    shifts () {
      return this.$store.getters.shifts
    },
    shift_shop_configurations () {
      return this.$store.getters.shift_shop_configurations
    },
    shift_class_haya_ho () {
      return this.$store.getters.shift_class_haya_ho
    },
    shift_class_haya_ka () {
      return this.$store.getters.shift_class_haya_ka
    },
    shift_class_naka_ho () {
      return this.$store.getters.shift_class_naka_ho
    },
    shift_class_oso_ho () {
      return this.$store.getters.shift_class_oso_ho
    },
    shift_class_oso_ka () {
      return this.$store.getters.shift_class_oso_ka
    },
    shift_class_kyuka () {
      return this.$store.getters.shift_class_kyuka
    },
    shift_class_sonota () {
      return this.$store.getters.shift_class_sonota
    },
    shifts_renkin_checkdatas () {
      return this.$store.getters.shifts_renkin_checkdatas
    },
    shop () {
      return this.$store.getters.shopDetail
    },
    shops () {
      return this.$store.getters.shopsAll
    },
    isSystemManagement () {
      return window.localStorage.getItem('user_authority') === '1'
    },
    getSelectYears () {
      var selectyears = []
      var startyear = 2018
      var endyear = this.getSelectedYear()
      for (var y = 2018; y <= endyear; y++) {
        selectyears.push(y)
      }
      return selectyears
    },
    getNoValue: function() {
      return '---'
    }
  },
  components: {
    AppHeader,
    ShiftImportDialog
  },
  methods: {
    getMyShopDetail: function() {
      var self = this
      var shop_id = window.localStorage.getItem('shop_id')
      var data = {}
      var callback = function() {
        self.shopName = self.shop.attributes['shop-name']
      }
      this.$store.dispatch('SHOP_DETAIL', { id: shop_id, data: data, callback: callback })
    },
    getSelectedYear: function() {
      var dt = new Date()
      // 16日以後は翌月の年を取得
      if (dt.getDate() >= 16) {
        //  dt.setMonth(dt.getMonth() + 1)

        var dtFirstDay = new Date(dt.getFullYear(), dt.getMonth(), 1)
        dtFirstDay.setMonth(dtFirstDay.getMonth() + 1)
        return dtFirstDay.getFullYear()
      } else {
        return dt.getFullYear()
      }
    },
    getSelectedMonth: function() {
      var dt = new Date()
      // 16日以後は翌月の月を取得
      if (dt.getDate() >= 16) {
        var dtFirstDay = new Date(dt.getFullYear(), dt.getMonth(), 1)
        dtFirstDay.setMonth(dtFirstDay.getMonth() + 1)
        return dtFirstDay.getMonth() + 1
      } else {
        return dt.getMonth() + 1
      }
    },
    isSelectMonthRange: function(month) {
      var ym = this.selectYear * 100 + month
      var ymend = this.getSelectedYear() * 100 + this.getSelectedMonth()
      if (ym <= ymend) {
        return true
      }
      return false
    },
    onClickSelectMonth: function(month) {
      if (!this.isSelectMonthRange(month)) return
      if (this.isNeedSaveFlag === true && !window.confirm('シフト表を保存していませんが、本当に月を変更しますか？')) {
        return false
      }
      this.isNeedSaveFlag = false
      this.selectMonth = month
      this.setCheckboxDisabledFlag = false
      this.search()
    },
    getShop: function () {
      const self = this
      const callback = function () {
        self.searchCallbackFlag = true
        // 退職者一覧店舗を表示しない
        let workIndex = 0
        for (let i = 0; i < self.shops.length; i++) {
          if (self.shops[i].id === '800') {
            workIndex = i
            break
          }
        }
        if (workIndex !== 0) {
          self.shops.splice(workIndex, 1)
        }
      }

      this.$store.dispatch('SHOP_ALL_GET', {callback: callback})
    },
    onClickDownload: async function() {
      let shop_id = window.localStorage.getItem('shop_id')
      if (this.isSystemManagement && this.searchShop) {
        shop_id = this.searchShop
      }
      let data = {
        'shop_id': shop_id,
        'target_date': this.getSelectedDate()
      }
      const res = await this.$store.dispatch('DOWNLOAD_SHIFT', { data: data })
      
      window.open(res.url)
      data = {
        file_name: res.file_name
      }
      window.setTimeout(async function () {
        await this.$store.dispatch('DELETE_SHIFT_FILE', { data: data })
      }, 5000)
    },
    getSelectedDate: function() {
      return this.selectYear + '-' + ('00' + this.selectMonth).slice(-2) + '-01'
    },
    // Excel 取込（F-SFT-02）。対象の店舗はダウンロードと同じ決め方（システム管理者は選択中の店舗）
    getTargetShopId: function () {
      var shopId = window.localStorage.getItem('shop_id')
      if (this.isSystemManagement && this.searchShop) {
        shopId = this.searchShop
      }
      return shopId
    },
    onClickOpenImport: function () {
      this.importDialogFlag = true
    },
    closeImportDialog: function () {
      this.importDialogFlag = false
    },
    // 取込を適用したら、画面のシフトを取込後の内容で再読込する（未保存の編集は取込側の確認で了承済み）
    onImportApplied: function () {
      this.isNeedSaveFlag = false
      this.search()
    },
    search: function(createdFlag = false) {
      var self = this
      var createdFlag = createdFlag
      var shop_id = window.localStorage.getItem('shop_id')
      if (this.isSystemManagement && this.searchShop) {
        shop_id = this.searchShop
      }
      this.searchCallbackFlag = false
      var data = {
        'shop_id': shop_id,
        'target_date': this.getSelectedDate()
      }
      var callback = function () {
        // 編集可能設定
        self.setCanEditCurrentMonth()
        // 店休日・予定・イベント名設定
        self.setShiftShopConfigurations()
        // 役職名選択肢設定
        self.setSelectUserTypes()
        // ユーザデータ設定
        self.setEditShifts()

        self.searchCallbackFlag = true
      }
      this.$store.dispatch('SHIFT_CREATE_GET', {data: data, callback: callback } )
    },
    setShiftShopConfigurations: function() {
      // データ初期化
      this.shiftShopConfigurations = []
      for (let key in this.shift_dates) {
        var data = {
          id: null,
          is_shop_holiday: false,
          plan_content: '',
          edit_flag: false,
          config_date: key
        }
        this.shiftShopConfigurations.push(data)
      }
      // データ設定
      var shift_shop_configurations_length = this.shiftShopConfigurations.length
      for (var i = 0; i < shift_shop_configurations_length; i++) {
        var data = this.shiftShopConfigurations[i]
        var config_date = data.config_date
        if (this.shift_shop_configurations[config_date]) {
          var shift_shop_configuration = this.shift_shop_configurations[config_date]
          data.id = shift_shop_configuration.id
          data.is_shop_holiday = (shift_shop_configuration.is_shop_holiday === 1)? true : false
          data.plan_content = (shift_shop_configuration.plan_content)? shift_shop_configuration.plan_content : ''
        }
        this.$set(this.shiftShopConfigurations, i, data)
      }
    },
    setSelectUserTypes: function() {
      // データ初期化
      this.selectUserTypes = {}
      this.selectUserType = []
      this.workUserTypeShifts = {}
      // データ設定
      for (var i in this.shifts) {
        var array = this.shifts[i]
        var keys = Object.keys(array)
        if (!keys) continue
        var first_key = keys.shift()
        if (first_key && array[first_key]) {
          var shift = array[first_key]
          var data = {
            user_type_id: shift.user_type_id,
            user_type_name: shift.user_type_name,
            user_type_priority: shift.user_type_priority
          }
          this.selectUserTypes[shift.user_type_priority] = data
        }
      }
      for (var key in this.selectUserTypes) {
        this.workUserTypeShifts[key] = {}
      }
    },
    setEditShifts: function() {
      // 各種変数初期化
      this.editShifts = {}
      // shifts設定
      for (var j in this.shifts) {
        var workInnerList = []
        var array = this.shifts[j]
        var user_type_priority = null
        for (let key in this.shift_dates) {
          var editShift = this.getInitEditShiftObject()
          if (array[key]) {
            var shift = array[key]
            editShift.id = shift.id
            editShift.user_id = shift.user_id
            editShift.shop_id = shift.shop_id
            editShift.user_type_id = shift.user_type_id
            editShift.shift_date = shift.shift_date
            editShift.week = shift.week
            editShift.is_public_holiday = shift.is_public_holiday
            editShift.comment = shift.comment
            editShift.shift_class_id = shift.shift_class_id
            editShift.time_from_hh = shift.time_from_hh
            editShift.time_from_mm = shift.time_from_mm
            editShift.time_to_hh = shift.time_to_hh
            editShift.time_to_mm = shift.time_to_mm
            editShift.break_time = shift.break_time
            editShift.is_edited = shift.is_edited
            editShift.is_default = shift.shift_class_is_default
            editShift.request_holiday_content = shift.request_holiday_content
            editShift.shift_class_view_name = shift.shift_class_view_name
            editShift.shift_class_select_name = shift.shift_class_select_name
            editShift.shift_class_class_name = shift.shift_class_class_name
            editShift.time_limit = shift.time_limit
            editShift.monday_shift_class_id = shift.monday_shift_class_id
            editShift.tuesday_shift_class_id = shift.tuesday_shift_class_id
            editShift.wednesday_shift_class_id = shift.wednesday_shift_class_id
            editShift.thursday_shift_class_id = shift.thursday_shift_class_id
            editShift.friday_shift_class_id = shift.friday_shift_class_id
            editShift.saturday_shift_class_id = shift.saturday_shift_class_id
            editShift.sunday_shift_class_id = shift.sunday_shift_class_id
            editShift.holiday_shift_class_id = shift.holiday_shift_class_id
            editShift.user_type_priority = shift.user_type_priority
            editShift.user_type_name = shift.user_type_name
            editShift.user_name = shift.user_name
            editShift.user_firstname = shift.user_firstname
            editShift.is_notice = 0
            if (user_type_priority == null) {
              user_type_priority = shift.user_type_priority
            }
          }
          workInnerList.push(editShift)
        }
        if (user_type_priority) {
          this.workUserTypeShifts[user_type_priority][j] = workInnerList
        }
      }
      for (var user_type_priority in this.workUserTypeShifts) {
        for (var user_id in this.workUserTypeShifts[user_type_priority]) {
          this.editShifts['_'+user_id] = this.workUserTypeShifts[user_type_priority][user_id]
        }
      }
    },
    getInitEditShiftObject: function() {
      return {
        id: null,
        user_id: null,
        shop_id: null,
        user_type_id: null,
        shift_date: null,
        week: null,
        is_public_holiday: 0,
        comment: null,
        shift_class_id: null,
        time_from_hh: 0,
        time_from_mm: 0,
        time_to_hh: 0,
        time_to_mm: 0,
        break_time: 0,
        is_edited: 0,
        is_default: 0,
        request_holiday_content: null,
        shift_class_view_name: null,
        shift_class_select_name: null,
        shift_class_class_name: null,
        time_limit: null,
        monday_shift_class_id: null,
        tuesday_shift_class_id: null,
        wednesday_shift_class_id: null,
        thursday_shift_class_id: null,
        friday_shift_class_id: null,
        saturday_shift_class_id: null,
        sunday_shift_class_id: null,
        holiday_shift_class_id: null,
        user_type_priority: null,
        user_type_name: null,
        user_name: null,
        user_firstname: null,
        is_notice: 0
      }
    },
    setCanEditCurrentMonth: function() {
      var dt = new Date()
      var year = dt.getFullYear()
      var month = dt.getMonth() + 1
      var date = dt.getDate()
      this.isDisableCurrentMonth = true
      this.isDisableSaveButton = true
      if (date <= 15) {
        // 本日が1〜15日の場合
        // 先月以前と来月以後編集不可、今月のみ編集可能
        if (year == this.selectYear && month == this.selectMonth) {
          this.isDisableCurrentMonth = false
          this.isDisableSaveButton = false
        }
      } else {
        // 本日が16日以後の場合
        // 先月以前のみ編集不可、今月と来月編集可能
        var nextyear = dt.getFullYear() + 1
        var dtFirstDay = new Date(year, dt.getMonth(), 1)
        dtFirstDay.setMonth(dtFirstDay.getMonth() + 1)

        var nextmonth = dtFirstDay.getMonth() + 1
        if ((year == this.selectYear && (month+1 == this.selectMonth || month == this.selectMonth)) || (nextyear == this.selectYear && nextmonth == this.selectMonth)) {
          this.isDisableCurrentMonth = false
          this.isDisableSaveButton = false
        }
      }
    },
    getVisibleUserFlag: function(shifts) {
      var user_type_id = null
      if (shifts && shifts.length > 0 && this.selectUserType.length > 0) {
        for (var i=0; i < shifts.length; i++) {
          if (shifts[i].user_type_id && !user_type_id) {
            user_type_id = shifts[i].user_type_id
          }
        }
        if (this.selectUserType.indexOf(user_type_id) < 0) {
          return false
        }
      }
      return true
    },
    workingMinutes: function(key) {
      // ユーザ勤務時間集計
      var shifts = this.editShifts[key]
      var shifts_length = shifts.length
      var workingMinute = 0
      for (var i = 0; i < shifts_length; i++) {
        workingMinute += this.calcDayWorkingHoursInterval(shifts[i])
      }
      return workingMinute
    },
    userShiftClassCounts: function(key, shift_class_class_name) {
      // ユーザ毎集計値集計
      var shifts = this.editShifts[key]
      var shifts_length = shifts.length
      var count = 0
      for (var i = 0; i < shifts_length; i++) {
        if (shifts[i].shift_class_class_name === shift_class_class_name) {
          count++
        }
      }
      return count
    },
    userHayahoCounts: function(key) {
      return this.userShiftClassCounts(key, 'a_haya_ho')
    },
    userHayakaCounts: function(key) {
      return this.userShiftClassCounts(key, 'b_haya_ka')
    },
    userNakahoCounts: function(key) {
      return this.userShiftClassCounts(key, 'c_naka_ho')
    },
    userOsohoCounts: function(key) {
      return this.userShiftClassCounts(key, 'd_oso_ho')
    },
    userOsokaCounts: function(key) {
      return this.userShiftClassCounts(key, 'e_oso_ka')
    },
    userKyuka1Counts: function(key) {
      // ユーザ毎集計値集計
      var shifts = this.editShifts[key]
      var shifts_length = shifts.length
      var count = 0
      for (var i = 0; i < shifts_length; i++) {
        var shift = shifts[i]
        if (shift.shift_class_class_name === 'f_kyuka') {
          if (shift.shift_class_select_name === '公休' || shift.shift_class_select_name === '希望') {
            count++
          }
        }
      }
      return count
    },
    userKyuka2Counts: function(key) {
      // ユーザ毎集計値集計
      var shifts = this.editShifts[key]
      var shifts_length = shifts.length
      var count = 0
      for (var i = 0; i < shifts_length; i++) {
        var shift = shifts[i]
        if (shift.shift_class_class_name === 'f_kyuka') {
          if (!(shift.shift_class_select_name === '公休' || shift.shift_class_select_name === '希望')) {
            count++
          }
        }
      }
      return count
    },
    userKyukaCounts: function(key) {
      return this.userKyuka1Counts(key) + this.userKyuka2Counts(key)
    },
    userSonotaCounts: function(key) {
      return this.userShiftClassCounts(key, 'g_sonota')
    },
    userHayaCounts: function(key) {
      return this.userHayahoCounts(key) + this.userHayakaCounts(key)
    },
    userOsoCounts: function(key) {
      return this.userOsohoCounts(key) + this.userOsokaCounts(key)
    },
    shiftShiftClassCounts: function(index, shift_class_class_name) {
      // 日付毎集計値集計
      var count = 0
      for (let key in this.editShifts) {
        var shifts = this.editShifts[key]
        var shift = shifts[index]
        if (this.getVisibleUserFlag(shifts) && (shift.shift_class_class_name === shift_class_class_name)) {
          count++
        }
      }
      return count
    },
    shiftHayahoCounts: function(index) {
      return this.shiftShiftClassCounts(index, 'a_haya_ho')
    },
    shiftHayakaCounts: function(index) {
      return this.shiftShiftClassCounts(index, 'b_haya_ka')
    },
    shiftNakahoCounts: function(index) {
      return this.shiftShiftClassCounts(index, 'c_naka_ho')
    },
    shiftOsohoCounts: function(index) {
      return this.shiftShiftClassCounts(index, 'd_oso_ho')
    },
    shiftOsokaCounts: function(index) {
      return this.shiftShiftClassCounts(index, 'e_oso_ka')
    },
    shiftKyuka1Counts: function(index) {
      // 日付毎集計値集計
      var count = 0
      for (let key in this.editShifts) {
        var shifts = this.editShifts[key]
        var shift = shifts[index]
        if (this.getVisibleUserFlag(shifts) && shift.shift_class_class_name === 'f_kyuka') {
          if (shift.shift_class_select_name === '公休' || shift.shift_class_select_name === '希望') {
            count++
          }
        }
      }
      return count
    },
    shiftKyuka2Counts: function(index) {
      // 日付毎集計値集計
      var count = 0
      for (let key in this.editShifts) {
        var shifts = this.editShifts[key]
        var shift = shifts[index]
        if (this.getVisibleUserFlag(shifts) && shift.shift_class_class_name === 'f_kyuka') {
          if (!(shift.shift_class_select_name === '公休' || shift.shift_class_select_name === '希望')) {
            count++
          }
        }
      }
      return count
    },
    shiftSonotaCounts: function(index) {
      return this.shiftShiftClassCounts(index, 'g_sonota')
    },
    editShopEvent: function(index) {
      if (this.isDisableCurrentMonth) return
      this.shiftShopConfigurations[index].edit_flag = true
      this.$nextTick(() => $('textarea[name="eventInput"]').eq(index).focus())
    },
    setShopEvent: function(index) {
      this.shiftShopConfigurations[index].edit_flag = false
      this.isNeedSaveFlag = true
    },
    zeroFilled: function(val, digit) {
      if (!val) val = ''
      return ('0000000000' + val).slice(-digit)
    },
    calcDayWorkingHoursInterval: function(shift) {
      // 休憩時間単位が分なので分基準で計算する
      var time_from_hh = shift['time_from_hh']
      var time_from_mm = shift['time_from_mm']
      var time_to_hh = shift['time_to_hh']
      var time_to_mm = shift['time_to_mm']
      var break_time = shift['break_time']
      var interval = ((time_to_hh * 60) + time_to_mm) - ((time_from_hh * 60) + time_from_mm) - break_time
      return interval
    },
    formatDayWorkingHoursIntervalString: function(interval) {
      if (interval > 0) {
        var interval_hh = parseInt(interval / 60, 10)
        var interval_mm = parseInt(interval % 60, 10)
        var hh_fill = 2
        if (interval >= 6000) {
          hh_fill = 3
        }
        return this.zeroFilled(interval_hh, hh_fill) + '時間' + this.zeroFilled(interval_mm, 2) + '分'
      }
      return '00時間00分'
    },
    getShiftConditionClassId: function(shift_date, shift) {
      // 表示判定
      if (shift.week === '月' && shift.monday_shift_class_id) {
        return shift.monday_shift_class_id
      } else if (shift.week === '火' && shift.tuesday_shift_class_id) {
        return shift.tuesday_shift_class_id
      } else if (shift.week === '水' && shift.wednesday_shift_class_id) {
        return shift.wednesday_shift_class_id
      } else if (shift.week === '木' && shift.thursday_shift_class_id) {
        return shift.thursday_shift_class_id
      } else if (shift.week === '金' && shift.friday_shift_class_id) {
        return shift.friday_shift_class_id
      } else if (shift.week === '土' && shift.saturday_shift_class_id) {
        return shift.saturday_shift_class_id
      } else if (shift.week === '日' && shift.sunday_shift_class_id) {
        return shift.sunday_shift_class_id
      } else if (shift_date.is_holiday && shift.holiday_shift_class_id) {
        return shift.holiday_shift_class_id
      }
      return 0
    },
    getShiftClass: function(shift_class_id, class_name) {
      if (!shift_class_id) return null
      if (class_name) {
        if (class_name === 'a_haya_ho') {
          return this.shift_class_haya_ho[shift_class_id]
        } else if (class_name === 'b_haya_ka') {
          return this.shift_class_haya_ka[shift_class_id]
        } else if (class_name === 'c_naka_ho') {
          return this.shift_class_naka_ho[shift_class_id]
        } else if (class_name === 'd_oso_ho') {
          return this.shift_class_oso_ho[shift_class_id]
        } else if (class_name === 'e_oso_ka') {
          return this.shift_class_oso_ka[shift_class_id]
        } else if (class_name === 'f_kyuka') {
          return this.shift_class_kyuka[shift_class_id]
        } else if (class_name === 'g_sonota') {
          return this.shift_class_sonota[shift_class_id]
        }
      } else {
        if (this.shift_class_haya_ho[shift_class_id]) {
          return this.shift_class_haya_ho[shift_class_id]
        } else if (this.shift_class_haya_ka[shift_class_id]) {
          return this.shift_class_haya_ka[shift_class_id]
        } else if (this.shift_class_naka_ho[shift_class_id]) {
          return this.shift_class_naka_ho[shift_class_id]
        } else if (this.shift_class_oso_ho[shift_class_id]) {
          return this.shift_class_oso_ho[shift_class_id]
        } else if (this.shift_class_oso_ka[shift_class_id]) {
          return this.shift_class_oso_ka[shift_class_id]
        } else if (this.shift_class_kyuka[shift_class_id]) {
          return this.shift_class_kyuka[shift_class_id]
        } else if (this.shift_class_sonota[shift_class_id]) {
          return this.shift_class_sonota[shift_class_id]
        }
      }
      return null
    },
    isShowShiftClass: function(shift_date, shift, class_name) {
      var shift_class_id = this.getShiftConditionClassId(shift_date, shift)
      return (this.getShiftClass(shift_class_id, class_name))? true:false
    },
    getYMDString: function(dt) {
      if (!dt) return ''
      var y = dt.getFullYear()
      var m = ("00" + (dt.getMonth()+1)).slice(-2)
      var d = ("00" + dt.getDate()).slice(-2)
      var result = y + "-" + m + "-" + d
      return result
    },
    isRenkin7: function(key, index, shift, shift_class) {
      // 休暇を選択している場合
      if (shift_class.class_name === 'f_kyuka') return false
      // 選択位置から7日間の範囲内に存在する休暇または未設定の位置をチェックする
      var workIndiciesMin = []
      var workIndiciesMax = []
      var shifts = this.editShifts[key]
      var user_id = shift.user_id
      var start = index - 6
      var end = index + 6
      var index_start = (start < 0)? 0:start
      var index_end = (end >= shifts.length)? shifts.length - 1:end

      var existLastMonthDataFlag = false
      if (start != index_start) {
        // 先月分考慮
        var base_date = new Date(shifts[0].shift_date)
        for (var i = start; i < 0; i++) {
          var work_date = new Date(base_date.toString())
          work_date.setDate(work_date.getDate() + i)
          var work_date_str = this.getYMDString(work_date)
          if (this.shifts_renkin_checkdatas[user_id] && this.shifts_renkin_checkdatas[user_id][work_date_str]) {
            var work_shift = this.shifts_renkin_checkdatas[user_id][work_date_str]
            if (work_shift) {
              existLastMonthDataFlag = true
            }
            if (work_shift && (utils.isBlank(work_shift.shift_class_class_name) || work_shift.shift_class_class_name === 'f_kyuka')) {
              workIndiciesMin.push(i)
            }
          }
        }
      }
      for (var i = index_start; i <= index_end; i++) {
        // 選択位置除外
        if (i === index) continue
        var work_shift = shifts[i]
        if (work_shift && (utils.isBlank(work_shift.shift_class_class_name) || work_shift.shift_class_class_name === 'f_kyuka')) {
          if (i < index) {
            workIndiciesMin.push(i)
          } else if (i > index) {
            workIndiciesMax.push(i)
          }
        }
      }
      var existNextMonthDataFlag = false
      if (end != index_end) {
        // 来月分考慮
        var base_date = new Date(shifts[shifts.length - 1].shift_date)
        for (var i = shifts.length; i <= end; i++) {
          var work_date = new Date(base_date.toString())
          work_date.setDate(work_date.getDate() + i)
          var work_date_str = this.getYMDString(work_date)
          if (this.shifts_renkin_checkdatas[user_id] && this.shifts_renkin_checkdatas[user_id][work_date_str]) {
            var work_shift = this.shifts_renkin_checkdatas[user_id][work_date_str]
            if (work_shift) {
              existNextMonthDataFlag = true
            }
            if (work_shift && (utils.isBlank(work_shift.shift_class_class_name) || work_shift.shift_class_class_name === 'f_kyuka')) {
              workIndiciesMax.push(i)
            }
          }
        }
      }
      // 前後に休暇が存在しない場合、7連勤確定
      var workIndiciesMin_length = workIndiciesMin.length
      // 先月データが存在しない場合はチェックしない
      if ((start == index_start) || existLastMonthDataFlag) {
        if (workIndiciesMin_length === 0) return true
      }
      var workIndiciesMax_length = workIndiciesMax.length
      // 来月データが存在しない場合はチェックしない
      if ((end == index_end) || existNextMonthDataFlag) {
        if (workIndiciesMax_length === 0) return true
      }
      // 前後に休暇が存在する場合
      var workIndiciesMinMax = workIndiciesMin[workIndiciesMin_length-1]
      var workIndiciesMaxMin = workIndiciesMax[0]
      if ((workIndiciesMaxMin - workIndiciesMinMax) > 7) {
        return true
      }
      return false
    },
    isTimeLimitOver: function(key, index, shift, shift_class) {
      // 休暇を選択している場合
      if (shift_class.class_name === 'f_kyuka') return false
      var working_minutes = this.workingMinutes(key)
      var time_limit_minutes = shift.time_limit * 60
      var shift_working_minutes = this.calcDayWorkingHoursInterval(shift_class)
      if ((working_minutes + shift_working_minutes) > time_limit_minutes) {
        return true
      }
      return false
    },
    isPastDate: function(date) {
      var date = new Date(date)
      var todayFul = new Date()
      var today = new Date(todayFul.getFullYear(), todayFul.getMonth(), todayFul.getDate(), 0, 0, 0)
      if (date < today) {
        return true
      }
      return false
    },
    onClickReflection: function () {
      // 各種変数初期化
      this.editShifts = {}
      // shifts設定
      for (var j in this.shifts) {
        var workInnerList = []
        var array = this.shifts[j]
        for (let key in this.shift_dates) {
          var editShift = this.getInitEditShiftObject()
          var user_type_priority = null
          if (array[key]) {
            var shift = array[key]
            editShift.id = shift.id
            editShift.user_id = shift.user_id
            editShift.shop_id = shift.shop_id
            editShift.user_type_id = shift.user_type_id
            editShift.shift_date = shift.shift_date
            editShift.week = shift.week
            editShift.is_public_holiday = shift.is_public_holiday
            editShift.comment = shift.comment
            editShift.shift_class_id = shift.shift_class_id
            editShift.time_from_hh = shift.time_from_hh
            editShift.time_from_mm = shift.time_from_mm
            editShift.time_to_hh = shift.time_to_hh
            editShift.time_to_mm = shift.time_to_mm
            editShift.break_time = shift.break_time
            editShift.is_edited = shift.is_edited
            editShift.is_default = shift.shift_class_is_default
            editShift.request_holiday_content = shift.request_holiday_content
            editShift.shift_class_view_name = shift.shift_class_view_name
            editShift.shift_class_select_name = shift.shift_class_select_name
            editShift.shift_class_class_name = shift.shift_class_class_name
            editShift.time_limit = shift.time_limit
            editShift.monday_shift_class_id = shift.monday_shift_class_id
            editShift.tuesday_shift_class_id = shift.tuesday_shift_class_id
            editShift.wednesday_shift_class_id = shift.wednesday_shift_class_id
            editShift.thursday_shift_class_id = shift.thursday_shift_class_id
            editShift.friday_shift_class_id = shift.friday_shift_class_id
            editShift.saturday_shift_class_id = shift.saturday_shift_class_id
            editShift.sunday_shift_class_id = shift.sunday_shift_class_id
            editShift.holiday_shift_class_id = shift.holiday_shift_class_id
            editShift.user_type_priority = shift.user_type_priority
            editShift.user_type_name = shift.user_type_name
            editShift.user_name = shift.user_name
            editShift.user_firstname = shift.user_firstname
            editShift.is_notice = 0
            user_type_priority = shift.user_type_priority
            if (!this.isPastDate(shift.shift_date) && shift.shift_class_view_name != '希望') {
              if (editShift.is_public_holiday == 1) {
                if (shift.holiday_shift_class_id != null) {
                  editShift.shift_class_id = shift.holiday_shift_class_id
                  this.getClassData(editShift.shift_class_id)
                  editShift.shift_class_view_name = this.classData.view_name
                  editShift.shift_class_select_name = this.classData.select_name
                  editShift.shift_class_class_name = this.classData.class_name
                  editShift.time_from_hh = this.classData.time_from_hh
                  editShift.time_from_mm = this.classData.time_from_mm
                  editShift.time_to_hh = this.classData.time_to_hh
                  editShift.time_to_mm = this.classData.time_to_mm
                  editShift.break_time = this.classData.break_time
                  editShift.is_default = this.classData.is_default
                }
              } else if (shift.week == '月') {
                if (shift.monday_shift_class_id != null) {
                  editShift.shift_class_id = shift.monday_shift_class_id
                  this.getClassData(editShift.shift_class_id)
                  editShift.shift_class_view_name = this.classData.view_name
                  editShift.shift_class_select_name = this.classData.select_name
                  editShift.shift_class_class_name = this.classData.class_name
                  editShift.time_from_hh = this.classData.time_from_hh
                  editShift.time_from_mm = this.classData.time_from_mm
                  editShift.time_to_hh = this.classData.time_to_hh
                  editShift.time_to_mm = this.classData.time_to_mm
                  editShift.break_time = this.classData.break_time
                  editShift.is_default = this.classData.is_default
                }
              } else if (shift.week == '火') {
                if (shift.tuesday_shift_class_id != null) {
                  editShift.shift_class_id = shift.tuesday_shift_class_id
                  this.getClassData(editShift.shift_class_id)
                  editShift.shift_class_view_name = this.classData.view_name
                  editShift.shift_class_select_name = this.classData.select_name
                  editShift.shift_class_class_name = this.classData.class_name
                  editShift.time_from_hh = this.classData.time_from_hh
                  editShift.time_from_mm = this.classData.time_from_mm
                  editShift.time_to_hh = this.classData.time_to_hh
                  editShift.time_to_mm = this.classData.time_to_mm
                  editShift.break_time = this.classData.break_time
                  editShift.is_default = this.classData.is_default
                }
              } else if (shift.week == '水') {
                if (shift.wednesday_shift_class_id != null) {
                  editShift.shift_class_id = shift.wednesday_shift_class_id
                  this.getClassData(editShift.shift_class_id)
                  editShift.shift_class_view_name = this.classData.view_name
                  editShift.shift_class_select_name = this.classData.select_name
                  editShift.shift_class_class_name = this.classData.class_name
                  editShift.time_from_hh = this.classData.time_from_hh
                  editShift.time_from_mm = this.classData.time_from_mm
                  editShift.time_to_hh = this.classData.time_to_hh
                  editShift.time_to_mm = this.classData.time_to_mm
                  editShift.break_time = this.classData.break_time
                  editShift.is_default = this.classData.is_default
                }
              } else if (shift.week == '木') {
                if (shift.thursday_shift_class_id != null) {
                  editShift.shift_class_id = shift.thursday_shift_class_id
                  this.getClassData(editShift.shift_class_id)
                  editShift.shift_class_view_name = this.classData.view_name
                  editShift.shift_class_select_name = this.classData.select_name
                  editShift.shift_class_class_name = this.classData.class_name
                  editShift.time_from_hh = this.classData.time_from_hh
                  editShift.time_from_mm = this.classData.time_from_mm
                  editShift.time_to_hh = this.classData.time_to_hh
                  editShift.time_to_mm = this.classData.time_to_mm
                  editShift.break_time = this.classData.break_time
                  editShift.is_default = this.classData.is_default
                }
              } else if (shift.week == '金') {
                if (shift.friday_shift_class_id != null) {
                  editShift.shift_class_id = shift.friday_shift_class_id
                  this.getClassData(editShift.shift_class_id)
                  editShift.shift_class_view_name = this.classData.view_name
                  editShift.shift_class_select_name = this.classData.select_name
                  editShift.shift_class_class_name = this.classData.class_name
                  editShift.time_from_hh = this.classData.time_from_hh
                  editShift.time_from_mm = this.classData.time_from_mm
                  editShift.time_to_hh = this.classData.time_to_hh
                  editShift.time_to_mm = this.classData.time_to_mm
                  editShift.break_time = this.classData.break_time
                  editShift.is_default = this.classData.is_default
                }
              } else if (shift.week == '土') {
                if (shift.saturday_shift_class_id != null) {
                  editShift.shift_class_id = shift.saturday_shift_class_id
                  this.getClassData(editShift.shift_class_id)
                  editShift.shift_class_view_name = this.classData.view_name
                  editShift.shift_class_select_name = this.classData.select_name
                  editShift.shift_class_class_name = this.classData.class_name
                  editShift.time_from_hh = this.classData.time_from_hh
                  editShift.time_from_mm = this.classData.time_from_mm
                  editShift.time_to_hh = this.classData.time_to_hh
                  editShift.time_to_mm = this.classData.time_to_mm
                  editShift.break_time = this.classData.break_time
                  editShift.is_default = this.classData.is_default
                }
              } else if (shift.week == '日') {
                if (shift.sunday_shift_class_id != null) {
                  editShift.shift_class_id = shift.sunday_shift_class_id
                  this.getClassData(editShift.shift_class_id)
                  editShift.shift_class_view_name = this.classData.view_name
                  editShift.shift_class_select_name = this.classData.select_name
                  editShift.shift_class_class_name = this.classData.class_name
                  editShift.time_from_hh = this.classData.time_from_hh
                  editShift.time_from_mm = this.classData.time_from_mm
                  editShift.time_to_hh = this.classData.time_to_hh
                  editShift.time_to_mm = this.classData.time_to_mm
                  editShift.break_time = this.classData.break_time
                  editShift.is_default = this.classData.is_default
                }
              }
            }
          }
          workInnerList.push(editShift)
        }
        if (user_type_priority) {
          this.workUserTypeShifts[user_type_priority][j] = workInnerList
        }
      }
      for (var user_type_priority in this.workUserTypeShifts) {
        for (var user_id in this.workUserTypeShifts[user_type_priority]) {
          this.editShifts['_'+user_id] = this.workUserTypeShifts[user_type_priority][user_id]
        }
      }
      this.$forceUpdate()
    },
    onClickSave: function() {
      var self = this
      var sendShifts = {}
      this.isNeedSaveFlag = false
      this.isDisableSaveButton = true
      // 保存データ設定
      // 保存に必要なものだけに絞る
      for (var j in this.editShifts) {
        var editShifts_length = this.editShifts[j].length
        var innerList = []
        for (var k = 0; k < editShifts_length; k++) {
          var shift = this.editShifts[j][k]
          // シフトデータが存在するものを保存対象とする
          if (shift.id) {
            // シフト情報転記
            var sendShift = {
              id: shift.id,
              user_id: shift.user_id,
              shift_date: shift.shift_date,
              comment: shift.comment,
              shift_class_id: shift.shift_class_id,
              shift_class_view_name: shift.shift_class_view_name,
              shift_class_class_name: shift.shift_class_class_name,
              time_from_hh: shift.time_from_hh,
              time_from_mm: shift.time_from_mm,
              time_to_hh: shift.time_to_hh,
              time_to_mm: shift.time_to_mm,
              break_time: shift.break_time,
              is_edited: shift.is_edited,
              is_notice: shift.is_notice
            }
            if (sendShift['shift_class_view_name'] == '希望') {
              sendShift['request_holiday_content'] = shift.request_holiday_content
            } else {
              sendShift['request_holiday_content'] = null
            }
            innerList.push(sendShift)
          }
        }
        sendShifts[j] = innerList
      }
      var data = {
        shift_shop_configurations: this.shiftShopConfigurations,
        shifts: sendShifts
      }
      this.$store.dispatch('SHIFT_CREATE_UPDATE', { data: data, callback: this.onSaved })
    },
    onSaved: function(val) {
      this.isDisableSaveButton = false
      if (val === 'success') {
        alert('保存に成功しました。')
      } else {
        alert('保存に失敗しました。')
      }
    },
    onChangeCheckShopHoliday: function(index) {
      this.isNeedSaveFlag = true
    },
    onClickShift: function(select_key, select_index, shift_date, shift, shift_class) {
      var shift_class_id = shift_class.id
      var shift_condition_class_id = this.getShiftConditionClassId(shift_date, shift)
      if (shift_condition_class_id != 0 && shift_class_id != shift_condition_class_id) {
        if (!window.confirm('勤務条件が設定されています。選択した項目を設定しますか？')) {
          return false
        }
      }
      if (this.isRenkin7(select_key, select_index, shift, shift_class)) {
        if (!window.confirm('7連勤になりますが、選択した項目を設定しますか？')) {
          return false
        }
      }
      var time_limit = shift.time_limit
      if ((time_limit > 0) && this.isTimeLimitOver(select_key, select_index, shift, shift_class)) {
        var alertmessage = '勤務時間上限'+time_limit+'時間を超えていますが、選択した項目を設定しますか？'
        if (!window.confirm(alertmessage)) {
          return false
        }
      }
      shift.shift_class_id = shift_class_id
      shift.shift_class_view_name = shift_class.view_name
      shift.shift_class_select_name = shift_class.select_name
      shift.shift_class_class_name = shift_class.class_name
      shift.time_from_hh = shift_class.time_from_hh
      shift.time_from_mm = shift_class.time_from_mm
      shift.time_to_hh = shift_class.time_to_hh
      shift.time_to_mm = shift_class.time_to_mm
      shift.break_time = shift_class.break_time
      shift.request_holiday_content = shift_class.content
      shift.is_edited = 0
      shift.is_default = shift_class.is_default
      this.isNeedSaveFlag = true
      // 休暇の場合は念のため強制的に時間をクリア
      if (shift_class.class_name === 'f_kyuka') {
        shift.time_from_hh = 0
        shift.time_from_mm = 0
        shift.time_to_hh = 0
        shift.time_to_mm = 0
        shift.break_time = 0
      }
      // 強制再描画
      this.$forceUpdate()
      // DOM制御によるプルダウン非表示
      $('#user-shift-icon-list-'+select_key+'_'+select_index).hide()
      // 次回hover時にプルダウンが表示されるようDOM制御で付与されたstyle="display:none"を削除する
      $('#user-button-'+select_key+'_'+select_index).hover(
        function() { $('#user-shift-icon-list-'+select_key+'_'+select_index).removeAttr('style') }
      )
    },
    getShiftClassClass: function(is_default, is_edited) {
      if (is_edited == 1) return 'shift-icon_changed'
      if (is_default == 1) return '-default'
      return ''
    },
    onClickOpenModal: function(key, index, shift_date, shift) {
      if (this.isDisableCurrentMonth) return
      this.modalFlag = true
      this.modalData['key'] = key
      this.modalData['index'] = index
      this.modalData['shift_date'] = shift_date
      var data = {
        id: null,
        user_id: null,
        shift_date: null,
        week: null,
        comment: null,
        shift_class_id: null,
        shift_class_view_name: null,
        shift_class_select_name: null,
        shift_class_class_name: null,
        time_from_hh: null,
        time_from_mm: null,
        time_to_hh: null,
        time_to_mm: null,
        break_time: null,
        is_edited: null,
        is_default: null,
        request_holiday_content: null,
        shift_date: null,
        user_name: null,
        user_firstname: null,
        user_type_name: null,
        time_limit: null,
        monday_shift_class_id: null,
        tuesday_shift_class_id: null,
        wednesday_shift_class_id: null,
        thursday_shift_class_id: null,
        friday_shift_class_id: null,
        saturday_shift_class_id: null,
        sunday_shift_class_id: null,
        holiday_shift_class_id: null,
        is_notice: 0
      }
      if (shift) {
        data.id = shift.id
        data.user_id = shift.user_id
        data.shift_date = shift.shift_date
        data.week = shift.week
        data.comment = shift.comment
        data.shift_class_id = shift.shift_class_id
        data.shift_class_view_name = shift.shift_class_view_name
        data.shift_class_select_name = shift.shift_class_select_name
        data.shift_class_class_name = shift.shift_class_class_name
        data.time_from_hh = this.zeroFilled(shift.time_from_hh, 2)
        data.time_from_mm = this.zeroFilled(shift.time_from_mm, 2)
        data.time_to_hh = this.zeroFilled(shift.time_to_hh, 2)
        data.time_to_mm = this.zeroFilled(shift.time_to_mm, 2)
        data.break_time = this.zeroFilled(shift.break_time, 2)
        data.is_edited =  shift.is_edited
        data.is_default =  shift.is_default
        data.request_holiday_content = shift.request_holiday_content
        data.shift_date = shift.shift_date
        data.user_name = shift.user_name
        data.user_firstname = shift.user_firstname
        data.user_type_name = shift.user_type_name
        data.time_limit = shift.time_limit
        data.monday_shift_class_id = shift.monday_shift_class_id
        data.tuesday_shift_class_id = shift.tuesday_shift_class_id
        data.wednesday_shift_class_id = shift.wednesday_shift_class_id
        data.thursday_shift_class_id = shift.thursday_shift_class_id
        data.friday_shift_class_id = shift.friday_shift_class_id
        data.saturday_shift_class_id = shift.saturday_shift_class_id
        data.sunday_shift_class_id = shift.sunday_shift_class_id
        data.holiday_shift_class_id = shift.holiday_shift_class_id
        data.is_notice = shift.is_notice
      }
      this.modalData['shift'] = data
      this.modalData['shiftClass'] = this.getShiftClass(shift.shift_class_id)
    },
    onClickSelectListItem: function(shift_class) {
      var shift_class_id = shift_class.id
      var shift_date = this.modalData['shift_date']
      var shift = this.modalData['shift']
      var shift_condition_class_id = this.getShiftConditionClassId(shift_date, shift)
      if (shift_condition_class_id != 0 && shift_class_id != shift_condition_class_id) {
          if (!window.confirm('勤務条件が設定されています。選択した項目を設定しますか？')) {
            return false
          }
      }
      if (this.isRenkin7(this.modalData['key'], this.modalData['index'], this.modalData['shift'], shift_class)) {
        if (!window.confirm('7連勤になりますが、選択した項目を設定しますか？')) {
          return false
        }
      }
      var time_limit = shift.time_limit
      if ((time_limit > 0) && this.isTimeLimitOver(this.modalData['key'], this.modalData['index'], shift, shift_class)) {
        var alertmessage = '勤務時間上限'+time_limit+'時間を超えていますが、選択した項目を設定しますか？'
        if (!window.confirm(alertmessage)) {
          return false
        }
      }
      this.modalData['shiftClass'] = shift_class
      var time_from_hh = this.zeroFilled(shift_class.time_from_hh, 2)
      var time_from_mm = this.zeroFilled(shift_class.time_from_mm, 2)
      var time_to_hh = this.zeroFilled(shift_class.time_to_hh, 2)
      var time_to_mm = this.zeroFilled(shift_class.time_to_mm, 2)
      var break_time = this.zeroFilled(shift_class.break_time, 2)
      // 休暇の場合は念のため強制的に時間をクリア
      if (shift_class.class_name === 'f_kyuka') {
        time_from_hh = '00'
        time_from_mm = '00'
        time_to_hh = '00'
        time_to_mm = '00'
        break_time = '00'
      }
      shift['shift_class_id'] = shift_class.id
      shift['shift_class_view_name'] = shift_class.view_name
      shift['shift_class_select_name'] = shift_class.select_name
      shift['shift_class_class_name'] = shift_class.class_name
      shift['time_from_hh'] = time_from_hh
      shift['time_from_mm'] = time_from_mm
      shift['time_to_hh'] = time_to_hh
      shift['time_to_mm'] = time_to_mm
      shift['break_time'] = break_time
      shift['is_edited'] = 0
      shift['is_default'] = shift_class.is_default
      // v-modelを使用すると入力の際に全再描画され遅いので、v-modelは使用しない
      $('#modal_comment').val(shift['comment'])
      $('#modal_time_from_hh').val(time_from_hh)
      $('#modal_time_from_mm').val(time_from_mm)
      $('#modal_time_to_hh').val(time_to_hh)
      $('#modal_time_to_mm').val(time_to_mm)
      $('#modal_break_time').val(break_time)
      this.controlModalInputDisabled(shift_class.class_name)
      this.modalSelectBoxFlag = false
    },
    controlModalInputDisabled: function(class_name) {
      if (class_name === 'f_kyuka') {
        $('#modal_time_from_hh').prop('disabled', true)
        $('#modal_time_from_mm').prop('disabled', true)
        $('#modal_time_to_hh').prop('disabled', true)
        $('#modal_time_to_mm').prop('disabled', true)
        $('#modal_break_time').prop('disabled', true)
      } else {
        $('#modal_time_from_hh').prop('disabled', false)
        $('#modal_time_from_mm').prop('disabled', false)
        $('#modal_time_to_hh').prop('disabled', false)
        $('#modal_time_to_mm').prop('disabled', false)
        $('#modal_break_time').prop('disabled', false)
      }
    },
    controlAllModalInputDisabled: function(class_name) {
      if (class_name === 'f_kyuka') {
        $('#modal-all_time_from_hh').prop('disabled', true)
        $('#modal-all_time_from_mm').prop('disabled', true)
        $('#modal-all_time_to_hh').prop('disabled', true)
        $('#modal-all_time_to_mm').prop('disabled', true)
        $('#modal-all_break_time').prop('disabled', true)
      } else {
        $('#modal-all_time_from_hh').prop('disabled', false)
        $('#modal-all_time_from_mm').prop('disabled', false)
        $('#modal-all_time_to_hh').prop('disabled', false)
        $('#modal-all_time_to_mm').prop('disabled', false)
        $('#modal-all_break_time').prop('disabled', false)
      }
    },
    closeModal: function() {
      for (var key in this.modalData) {
        this.modalData[key] = null
      }
      this.modalFlag = false
      this.modalSelectBoxFlag = false
    },
    saveModalData: function(is_notice) {
      var key = this.modalData['key']
      var index = this.modalData['index']
      var shift = this.modalData['shift']
      var shiftClass = this.modalData['shiftClass']
      if (shift['shift_class_id']) {
        var editShift = this.editShifts[key][index]
        editShift.shift_class_id = shift['shift_class_id']
        editShift.shift_class_view_name = shift['shift_class_view_name']
        editShift.shift_class_select_name = shift['shift_class_select_name']
        editShift.shift_class_class_name = shift['shift_class_class_name']
        // v-modelを使用すると入力の際に全再描画され遅いので、v-modelは使用しない
        editShift.comment = $('#modal_comment').val()
        var modal_time_from_hh = Number($('#modal_time_from_hh').val())
        var modal_time_from_mm = Number($('#modal_time_from_mm').val())
        var modal_time_to_hh = Number($('#modal_time_to_hh').val())
        var modal_time_to_mm = Number($('#modal_time_to_mm').val())
        var modal_break_time = Number($('#modal_break_time').val())
        editShift.time_from_hh = modal_time_from_hh
        editShift.time_from_mm = modal_time_from_mm
        editShift.time_to_hh = modal_time_to_hh
        editShift.time_to_mm = modal_time_to_mm
        editShift.break_time = modal_break_time
        editShift.request_holiday_content =  shift['request_holiday_content']
        if ((modal_time_from_hh != shiftClass['time_from_hh']) ||
            (modal_time_from_mm != shiftClass['time_from_mm']) ||
            (modal_time_to_hh != shiftClass['time_to_hh']) ||
            (modal_time_to_mm != shiftClass['time_to_mm']) ||
            (modal_break_time != shiftClass['break_time'])) {
          editShift.is_edited = 1
        } else {
          editShift.is_edited = 0
        }
        editShift.is_default = shift['is_default']
        editShift.is_notice = is_notice
        this.isNeedSaveFlag = true
      }
    },
    crearModalData: function() {
      var key = this.modalData['key']
      var index = this.modalData['index']

      var editShift = this.editShifts[key][index]
      editShift.shift_class_id = null
      editShift.shift_class_view_name = null
      editShift.shift_class_select_name = null
      editShift.shift_class_class_name = null
      editShift.comment = null
      editShift.time_from_hh = 0
      editShift.time_from_mm = 0
      editShift.time_to_hh = 0
      editShift.time_to_mm = 0
      editShift.break_time = 0
      editShift.request_holiday_content = null
      editShift.is_edited = 0
      editShift.is_default = 0
      editShift.is_notice = 0
      this.isNeedSaveFlag = true
    },
    saveModal: function() {
      // 通知なし is_notice = 0
      this.saveModalData(0)
      this.closeModal()
      // 強制再描画
      this.$forceUpdate()
    },
    noticeSaveModal: function() {
      // 通知あり is_notice = 1
      this.saveModalData(1)
      this.closeModal()
      // 強制再描画
      this.$forceUpdate()
    },
    clearModal: function() {
      this.crearModalData()
      this.closeModal()
      // 強制再描画
      this.$forceUpdate()
    },
    getName(shift) {
      for (var key in shift) {
        if (shift[key].user_name) {
          return shift[key].user_name + ' ' + shift[key].user_firstname
        }
      }
      return ''
    },
    getUserType(shift) {
      for (var key in shift) {
        if (shift[key].user_type_name) {
          return shift[key].user_type_name
        }
      }
      return ''
    },
    getLimit(shift) {
      for (var key in shift) {
        if (shift[key].time_limit) {
          return shift[key].time_limit
        }
      }
      return ''
    },
    getClassData: function(classId) {
      for (var key in this.shift_class_haya_ho) {
        if (key == classId) {
          this.classData.view_name = this.shift_class_haya_ho[key].view_name
          this.classData.select_name = this.shift_class_haya_ho[key].select_name
          this.classData.class_name = this.shift_class_haya_ho[key].class_name
          this.classData.time_from_hh = this.shift_class_haya_ho[key].time_from_hh
          this.classData.time_from_mm = this.shift_class_haya_ho[key].time_from_mm
          this.classData.time_to_hh = this.shift_class_haya_ho[key].time_to_hh
          this.classData.time_to_mm = this.shift_class_haya_ho[key].time_to_mm
          this.classData.break_time = this.shift_class_haya_ho[key].break_time
          this.classData.is_default = this.shift_class_haya_ho[key].is_default
        }
      }
      for (var key in this.shift_class_haya_ka) {
        if (key == classId) {
          this.classData.view_name = this.shift_class_haya_ka[key].view_name
          this.classData.select_name = this.shift_class_haya_ka[key].select_name
          this.classData.class_name = this.shift_class_haya_ka[key].class_name
          this.classData.time_from_hh = this.shift_class_haya_ka[key].time_from_hh
          this.classData.time_from_mm = this.shift_class_haya_ka[key].time_from_mm
          this.classData.time_to_hh = this.shift_class_haya_ka[key].time_to_hh
          this.classData.time_to_mm = this.shift_class_haya_ka[key].time_to_mm
          this.classData.break_time = this.shift_class_haya_ka[key].break_time
          this.classData.is_default = this.shift_class_haya_ka[key].is_default
        }
      }
      for (var key in this.shift_class_kyuka) {
        if (key == classId) {
          this.classData.view_name = this.shift_class_kyuka[key].view_name
          this.classData.select_name = this.shift_class_kyuka[key].select_name
          this.classData.class_name = this.shift_class_kyuka[key].class_name
          this.classData.time_from_hh = this.shift_class_kyuka[key].time_from_hh
          this.classData.time_from_mm = this.shift_class_kyuka[key].time_from_mm
          this.classData.time_to_hh = this.shift_class_kyuka[key].time_to_hh
          this.classData.time_to_mm = this.shift_class_kyuka[key].time_to_mm
          this.classData.break_time = this.shift_class_kyuka[key].break_time
          this.classData.is_default = this.shift_class_kyuka[key].is_default
        }
      }
      for (var key in this.shift_class_naka_ho) {
        if (key == classId) {
          this.classData.view_name = this.shift_class_naka_ho[key].view_name
          this.classData.select_name = this.shift_class_naka_ho[key].select_name
          this.classData.class_name = this.shift_class_naka_ho[key].class_name
          this.classData.time_from_hh = this.shift_class_naka_ho[key].time_from_hh
          this.classData.time_from_mm = this.shift_class_naka_ho[key].time_from_mm
          this.classData.time_to_hh = this.shift_class_naka_ho[key].time_to_hh
          this.classData.time_to_mm = this.shift_class_naka_ho[key].time_to_mm
          this.classData.break_time = this.shift_class_naka_ho[key].break_time
          this.classData.is_default = this.shift_class_naka_ho[key].is_default
        }
      }
      for (var key in this.shift_class_oso_ho) {
        if (key == classId) {
          this.classData.view_name = this.shift_class_oso_ho[key].view_name
          this.classData.select_name = this.shift_class_oso_ho[key].select_name
          this.classData.class_name = this.shift_class_oso_ho[key].class_name
          this.classData.time_from_hh = this.shift_class_oso_ho[key].time_from_hh
          this.classData.time_from_mm = this.shift_class_oso_ho[key].time_from_mm
          this.classData.time_to_hh = this.shift_class_oso_ho[key].time_to_hh
          this.classData.time_to_mm = this.shift_class_oso_ho[key].time_to_mm
          this.classData.break_time = this.shift_class_oso_ho[key].break_time
          this.classData.is_default = this.shift_class_oso_ho[key].is_default
        }
      }
      for (var key in this.shift_class_oso_ka) {
        if (key == classId) {
          this.classData.view_name = this.shift_class_oso_ka[key].view_name
          this.classData.select_name = this.shift_class_oso_ka[key].select_name
          this.classData.class_name = this.shift_class_oso_ka[key].class_name
          this.classData.time_from_hh = this.shift_class_oso_ka[key].time_from_hh
          this.classData.time_from_mm = this.shift_class_oso_ka[key].time_from_mm
          this.classData.time_to_hh = this.shift_class_oso_ka[key].time_to_hh
          this.classData.time_to_mm = this.shift_class_oso_ka[key].time_to_mm
          this.classData.break_time = this.shift_class_oso_ka[key].break_time
          this.classData.is_default = this.shift_class_oso_ka[key].is_default
        }
      }
      for (var key in this.shift_class_sonota) {
        if (key == classId) {
          this.classData.view_name = this.shift_class_sonota[key].view_name
          this.classData.select_name = this.shift_class_sonota[key].select_name
          this.classData.class_name = this.shift_class_sonota[key].class_name
          this.classData.time_from_hh = this.shift_class_sonota[key].time_from_hh
          this.classData.time_from_mm = this.shift_class_sonota[key].time_from_mm
          this.classData.time_to_hh = this.shift_class_sonota[key].time_to_hh
          this.classData.time_to_mm = this.shift_class_sonota[key].time_to_mm
          this.classData.break_time = this.shift_class_sonota[key].break_time
          this.classData.is_default = this.shift_class_sonota[key].is_default
        }
      }

    },
    content: function (word) {
      return word ? word.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/\r?\n/g, '<br>') : ''
    },
    removeUserLine: function (key) {
      delete this.editShifts[key]
      this.$forceUpdate()
    },
    shiftCellStyleClass: function (date, key, innerIndex, outerIndex=0) {
      return {
        'bg-saturday': date.week === '土',
        'bg-sunday': date.week === '日',
        'bg-holiday': date.is_holiday,
        'bg-shop_holiday': this.shiftShopConfigurations[innerIndex].is_shop_holiday,
        'bg-odd': outerIndex % 2 !== 0
      }
    },
    changeCheckedShift: function (shiftClass) {
      var reg = /(\_\d+)\-(\d+)\-(\d+)\-(\d+)/

      if (this.checkedData.length === 1) {
        var data = this.checkedData[0].match(reg)
        var user = data[1]
        var year = data[2]
        var month = data[3]
        var date = data[4]
        var dateIndex = parseInt(date, 10) - 1

        var shift = this.editShifts[user][dateIndex]
        var shift_class_class = this.getDefaultShift(this[shiftClass])

        var shift_class_id = shift_class_class.id
        var shift_date = year + '-' + month + '-' + date

        var shift_condition_class_id = this.getShiftConditionClassId(shift_date, shift)
        if (shift_condition_class_id != 0 && shift_class_id != shift_condition_class_id) {
          if (!window.confirm('勤務条件が設定されています。選択した項目を設定しますか？')) {
            return false
          }
        }
        if (this.isRenkin7(user, dateIndex, shift, shift_class_class)) {
          if (!window.confirm('7連勤になりますが、選択した項目を設定しますか？')) {
            return false
          }
        }
        var time_limit = shift.time_limit
        if ((time_limit > 0) && this.isTimeLimitOver(user, dateIndex, shift, shift_class_class)) {
          var alertmessage = '勤務時間上限'+time_limit+'時間を超えていますが、選択した項目を設定しますか？'
          if (!window.confirm(alertmessage)) {
            return false
          }
        }

        this.changeShift(user, dateIndex, shift_class_class)

        var nextDate = parseInt(date, 10) + 1
        var nextDateData = (nextDate < 10) ? '0' + nextDate : nextDate
        var dateLength = this.shiftShopConfigurations.length
        var firstData = `${user}-${year}-${month}-${nextDateData}`

        // チェックを外す
        this.checkedData = []
        // 翌日のチェックをつける
        if (nextDate <= dateLength) {
          this.checkedData.push(firstData)
          this.$forceUpdate
        }

      } else if (this.checkedData.length > 1) {
        for (var key in this.checkedData) {
          var data = this.checkedData[key].match(reg)
          var user = data[1]
          var date = data[4]
          var dateIndex = parseInt(date, 10) - 1
          var shift_class_class = this.getDefaultShift(this[shiftClass])
          this.changeShift(user, dateIndex, shift_class_class)
        }
        // チェックを外す
        this.checkedData = []

      }
    },
    changeShift: function(select_key, select_index, shift_class_class) {
      var shift = this.editShifts[select_key][select_index]

      shift.shift_class_id = shift_class_class.id
      shift.shift_class_view_name = shift_class_class.view_name
      shift.shift_class_select_name = shift_class_class.select_name
      shift.shift_class_class_name = shift_class_class.class_name
      shift.time_from_hh = shift_class_class.time_from_hh
      shift.time_from_mm = shift_class_class.time_from_mm
      shift.time_to_hh = shift_class_class.time_to_hh
      shift.time_to_mm = shift_class_class.time_to_mm
      shift.break_time = shift_class_class.break_time
      shift.request_holiday_content = shift_class_class.content
      shift.is_edited = 0
      shift.is_default = shift_class_class.is_default
      this.isNeedSaveFlag = true
      // 休暇の場合は念のため強制的に時間をクリア
      if (shift_class_class.class_name === 'f_kyuka') {
        shift.time_from_hh = 0
        shift.time_from_mm = 0
        shift.time_to_hh = 0
        shift.time_to_mm = 0
        shift.break_time = 0
      }
      // 強制再描画
      this.$forceUpdate()
    },
    judgeKeyCode: function (event) {
      if (event.shiftKey && event.keyCode === 90) {
        this.changeCheckedShift('shift_class_haya_ho')
      } else if (event.shiftKey && event.keyCode === 88) {
        this.changeCheckedShift('shift_class_oso_ho')
      } else if (event.shiftKey && event.keyCode === 67) {
        this.changeCheckedShift('shift_class_naka_ho')
      } else if (event.shiftKey && event.keyCode === 86) {
        this.changeCheckedShift('shift_class_kyuka')
      }
    },
    fixedTableHead: function () {
      var scroll = window.scrollY
      if (scroll > 490){
        $("#is-scroll-fix").addClass("-fixed")
      } else {
        $("#is-scroll-fix").removeClass("-fixed")
      }
    },
    onClickOpenChangeAllModal: function (outerKey) {
      this.changeAllModalData.key = outerKey
      var data = {
        id: null,
        user_id: null,
        shift_date: null,
        week: null,
        comment: null,
        shift_class_id: null,
        shift_class_view_name: null,
        shift_class_select_name: null,
        shift_class_class_name: null,
        time_from_hh: null,
        time_from_mm: null,
        time_to_hh: null,
        time_to_mm: null,
        break_time: null,
        is_edited: null,
        is_default: null,
        request_holiday_content: null,
        shift_date: null,
        user_name: null,
        user_firstname: null,
        user_type_name: null,
        time_limit: null,
        monday_shift_class_id: null,
        tuesday_shift_class_id: null,
        wednesday_shift_class_id: null,
        thursday_shift_class_id: null,
        friday_shift_class_id: null,
        saturday_shift_class_id: null,
        sunday_shift_class_id: null,
        holiday_shift_class_id: null,
        is_notice: 0
      }
      this.changeAllModalData['shift'] = data
      this.changeAllModalFlag = true
    },
    closeChangeAllModal: function () {
      this.changeAllModalFlag = false
    },
    onClickSelectListItemAll: function(shift_class) {
      this.changeAllModalData['shift'] = shift_class
      var time_from_hh = this.zeroFilled(shift_class.time_from_hh, 2)
      var time_from_mm = this.zeroFilled(shift_class.time_from_mm, 2)
      var time_to_hh = this.zeroFilled(shift_class.time_to_hh, 2)
      var time_to_mm = this.zeroFilled(shift_class.time_to_mm, 2)
      var break_time = this.zeroFilled(shift_class.break_time, 2)
      // 休暇の場合は念のため強制的に時間をクリア
      if (shift_class.class_name === 'f_kyuka') {
        time_from_hh = '00'
        time_from_mm = '00'
        time_to_hh = '00'
        time_to_mm = '00'
        break_time = '00'
      }

      // v-modelを使用すると入力の際に全再描画され遅いので、v-modelは使用しない
      $('#modal-all_time_from_hh').val(time_from_hh)
      $('#modal-all_time_from_mm').val(time_from_mm)
      $('#modal-all_time_to_hh').val(time_to_hh)
      $('#modal-all_time_to_mm').val(time_to_mm)
      $('#modal-all_break_time').val(break_time)

      var shift = this.changeAllModalData['shift']
      shift['shift_class_id'] = shift_class.id
      shift['shift_class_view_name'] = shift_class.view_name
      shift['shift_class_select_name'] = shift_class.select_name
      shift['shift_class_class_name'] = shift_class.class_name
      shift['time_from_hh'] = time_from_hh
      shift['time_from_mm'] = time_from_mm
      shift['time_to_hh'] = time_to_hh
      shift['time_to_mm'] = time_to_mm
      shift['break_time'] = break_time
      shift['is_edited'] = 0
      shift['is_default'] = shift_class.is_default

      this.controlAllModalInputDisabled(shift_class.class_name)
      this.changeAllModalSelectBoxFlag = false
    },
    saveChangeAllModal: function() {

      var userkey = this.changeAllModalData.key
      var shift = this.editShifts[userkey]
      var shiftClass = this.changeAllModalData.shift

      // シフトが選択されていなかったら変更しない
      if(shiftClass['shift_class_select_name'] === null){
        return false
      }

      if (!window.confirm("希望休以外のシフトを上書きしますか？")) {
        return false
      }

      for(var key in shift){
        // 希望休のとき変更しない
        if(shift[key]['shift_class_select_name'] === '希望'){
          continue
        }
        // 過去日のとき変更しない
        if (this.isPastDate(shift[key]['shift_date'])) {
          continue
        }

        var time_from_hh = Number($('#modal-all_time_from_hh').val())
        var time_from_mm = Number($('#modal-all_time_from_mm').val())
        var time_to_hh = Number($('#modal-all_time_to_hh').val())
        var time_to_mm = Number($('#modal-all_time_to_mm').val())
        var break_time = Number($('#modal-all_break_time').val())
        
        shift[key]['is_default'] = shiftClass['is_default']
        shift[key]['shift_class_class_name'] = shiftClass['shift_class_class_name']
        shift[key]['shift_class_id'] = shiftClass['shift_class_id']
        shift[key]['shift_class_select_name'] = shiftClass['shift_class_select_name']
        shift[key]['shift_class_view_name'] = shiftClass['shift_class_view_name']
        shift[key]['time_from_hh'] = time_from_hh
        shift[key]['time_from_mm'] = time_from_mm
        shift[key]['time_to_hh'] = time_to_hh
        shift[key]['time_to_mm'] = time_to_mm
        shift[key]['break_time'] = break_time

        if ((time_from_hh != shiftClass['time_from_hh']) ||
          (time_from_mm != shiftClass['time_from_mm']) ||
          (time_to_hh != shiftClass['time_to_hh']) ||
          (time_to_mm != shiftClass['time_to_mm']) ||
          (break_time != shiftClass['break_time'])) {
          shift[key].is_edited = 1
        } else {
          shift[key].is_edited = 0
        }
        shift[key]['is_notice'] = 0
        this.isNeedSaveFlag = true
      }
      this.closeChangeAllModal()
      // 強制再描画
      this.$forceUpdate()
    },
    clearChangeAllModalData: function () {
      var userKey = this.changeAllModalData.key
      var editShift = this.editShifts[userKey]

      for(var key in editShift){
        if(editShift[key]['shift_class_select_name'] === '希望'){
          continue
        }
        editShift[key].shift_class_id = null
        editShift[key].shift_class_view_name = null
        editShift[key].shift_class_select_name = null
        editShift[key].shift_class_class_name = null
        editShift[key].comment = null
        editShift[key].time_from_hh = 0
        editShift[key].time_from_mm = 0
        editShift[key].time_to_hh = 0
        editShift[key].time_to_mm = 0
        editShift[key].break_time = 0
        editShift[key].request_holiday_content = null
        editShift[key].is_edited = 0
        editShift[key].is_default = 0
        editShift[key].is_notice = 0
        this.isNeedSaveFlag = true
      }
    },
    clearChangeAllModal: function () {
      if (!window.confirm("希望休以外のシフトをクリアしますか？")) {
        return false
      }
      this.clearChangeAllModalData()
      this.closeChangeAllModal()
      // 強制再描画
      this.$forceUpdate()
    },
    getDefaultShift: function (shift_class) {
      var shift_class_class
      if (shift_class === this['shift_class_kyuka']) {
        for(var key in shift_class){
          if(shift_class[key]['select_name'] === '公休'){
            shift_class_class = shift_class[key]
            break
          }
        }
      } else {
        for(var key in shift_class){
          if(shift_class[key]['is_default'] === 1){
            shift_class_class = shift_class[key]
            break
          }
        }
      }
      return shift_class_class
    },
    setCheckboxDisabled: function () {
      Object.keys(this['shift_dates']).forEach(function(key){
        if (this.$refs[key] && this.isPastDate(key)) {
          for (var i=0; i<this.$refs[key].length; i++) {
            this.$refs[key][i].classList.add('-is-disabled')
            if(this.$refs['checkbox' + key] && this.$refs['checkbox' + key][i]) {
              this.$refs['checkbox' + key][i].disabled = true
            }
          }
        }
      }, this)
      this.setCheckboxDisabledFlag = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/shift-create.js